import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { Home, ArrowLeft, Shield, AlertTriangle } from "lucide-react";
import { useAppSelector } from "../redux/hooks";

export function NotFoundPage() {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);

  const handleGoHome = () => {
    if (user) {
      // Navigate based on user role
      if (user.isAdmin) {
        navigate("/admin/dashboard");
      } else {
        navigate("/pharmacy/dashboard");
      }
    } else {
      navigate("/auth/login");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-gray-50 to-green-100 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Logo and Brand */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-green-600 rounded-xl flex items-center justify-center shadow-lg">
              <Shield className="w-8 h-8 text-white" />
            </div>
          </div>
          <h1 className="text-3xl font-semibold text-gray-900 mb-2">
            Courier-RX
          </h1>
          <p className="text-gray-600">
            Enterprise Pharmacy Delivery Platform
          </p>
        </div>

        <Card className="shadow-xl border-0 bg-white/80 backdrop-blur-sm">
          <div className="p-8 text-center">
            {/* 404 Icon */}
            <div className="flex items-center justify-center mb-6">
              <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-12 h-12 text-red-500" />
              </div>
            </div>

            {/* 404 Content */}
            <div className="mb-8">
              <h1 className="text-8xl font-bold text-gray-300 mb-2">404</h1>
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                Page Not Found
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed max-w-md mx-auto">
                The page you're looking for doesn't exist or has been moved. 
                Let's get you back on track.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
              <Button
                onClick={handleGoHome}
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 text-sm font-medium"
                size="lg"
              >
                <Home className="w-4 h-4 mr-2" />
                Go to Dashboard
              </Button>
              <Button
                onClick={handleGoBack}
                variant="outline"
                className="border-gray-300 text-gray-700 hover:bg-gray-50 px-6 py-2.5 text-sm font-medium"
                size="lg"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Go Back
              </Button>
            </div>

            {/* Help Text */}
            <div className="mt-8 pt-2 border-t border-gray-100">
              <p className="text-sm text-gray-500">
                Need assistance? Contact your system administrator or 
                <span className="text-green-600 font-medium"> support team</span>
              </p>
            </div>
          </div>
        </Card>

        {/* Additional Information */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            If you believe this is an error, please check the URL or contact support.
          </p>
        </div>
      </div>
    </div>
  );
}

